<template>
  <div id="img-to-show" @click="galeryOff(true)">
    <img draggable="false" :src="giveMePathPlease(imgToShow)" @click="galeryOff()" v-if="!Array.isArray(imgToShow)" />
    <div class="img-array" v-if="Array.isArray(imgToShow)">
      <div
        class="img-array-show"
        :style="{ width: imgToShow.length * 1920 + 'px', left: '-' + actualIndex * 1920 + 'px' }"
      >
        <!-- <img v-if="currentImg" :src="giveMeImagePlease(currentImg.src)" /> -->
        <div class="current-image-box" v-for="(it, itemIndex) in imgToShow" :key="'images-' + itemIndex">
          <img draggable="false" :src="giveMePathPlease(it)" />
        </div>
      </div>
      <div class="img-tumb">
        <div
          class="img-box"
          @click="actualIndex = imgIndex"
          :key="'img-tumb-' + imgIndex"
          v-for="(tumb, imgIndex) in imgToShow"
          :style="setStyle(imgIndex)"
        >
          <img draggable="false" :src="giveMePathPlease(tumb)" />
        </div>
      </div>
    </div>
    <svg id="exit" @click="galeryOff()" width="calc(1080px * 0.05)" height="calc(1080px * 0.05)" viewBox="0 0 24 24">
      <path
        d="M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
      />
    </svg>
  </div>
</template>
<script>
export default {
  name: 'img-to-show',
  data() {
    return {
      actualIndex: 0,
    };
  },
  methods: {
    giveMePathPlease(path) {
      // console.log(path);
      if (path) {
        return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
      }
    },
    setStyle(itemIndex) {
      // if (this.currentImg) {
      if (itemIndex == this.actualIndex) return { opacity: 1 };
      // }
    },
    galeryOff(state) {
      if (state) {
        if (!Array.isArray(this.imgToShow)) {
          this.$store.commit('STATE_SET_GALERY_OPEN', false);
        }
      } else {
        this.$store.commit('STATE_SET_GALERY_OPEN', false);
      }
      // this.$parent.$emit('stopSound');
    },
  },
  computed: {
    imgToShow() {
      return this.$store.getters.getImgToShow;
    },
  },
};
</script>
<style lang="sass" scoped>
@import '../../style/base'
@import '../../style/animation'

#img-to-show
  position: fixed
  top: 0
  left: 0
  width: 100%
  height: 100%
  background: rgba(255,255,255,1)
  z-index: 2000
  text-align: center
  display: flex
  align-items: center
  justify-content: center
  .img-array
    width: 100%
    height: 100%
    .img-tumb
      width: 100%
      height: 10%
      position: absolute
      bottom: 10px
      left: 0
      display: flex
      align-items: center
      flex-direction: row
      justify-content: center
      .img-box
        // margin-top: 125px
        display: flex
        align-items: center
        flex-direction: row
        justify-content: center
        max-width: 192px
        height: 100%
        opacity: .5
        transition: .5s
        cursor: pointer
        img
          border: 3px white solid
          box-shadow: 0px 0px 16px rgba(0,0,0, 0.4)
          max-width: 90%
          max-height: 192px
          object-fit: scale-down
        &:hover
          margin-top: 0
          opacity: 1
    .img-array-show
      width: 100%
      height: 90%
      position: absolute
      top: 0
      left: 0
      display: flex
      align-items: center
      flex-direction: row
      justify-content: flex-start
      transition: .5s
      .current-image-box
        width: 1920px
        height: 100%
        display: flex
        align-items: center
        flex-direction: row
        justify-content: center
        img
          // border: 10px white solid
          // box-shadow: 0px 0px 16px rgba(0,0,0, 0.4)
          max-width: 90%
          max-height: 90%
          object-fit: scale-down
  #exit
    cursor: pointer
    top: calc(1080px * 0.01)
    right: calc(1080px * 0.01)
    width: calc(1080px * 0.05)
    height: calc(1080px * 0.05)
    position: fixed
    path
    fill: $MAC_SECONDARY_COLOR
  img
    max-width: 80%
    width: 80%
    max-height: 80%
    object-fit: contain
</style>
